import { useSelector } from 'react-redux';

import { selectAssessmentResultOptions } from '../services/selectors';

export const useAssessmentResultOptions = () => useSelector(selectAssessmentResultOptions);
